import { FC, ReactNode } from "react";
import { Flex, Td, Tr } from "@chakra-ui/react";
import { RowDescription } from "./RowDescription";

interface Props {
  col1?: ReactNode;
  col2?: ReactNode;
  col3?: ReactNode;
}

export const TableRow: FC<Props> = ({ col1, col2, col3 }) => {
  return (
    <Tr>
      <Td>
        <RowDescription>{col1}</RowDescription>
      </Td>
      <Td>
        <Flex align="center" justify="center" w="full">
          {col2}
        </Flex>
      </Td>
      <Td>
        <Flex align="center" justify="center" w="full">
          {col3}
        </Flex>
      </Td>
    </Tr>
  );
};
